import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import React from "react";
import styled from "styled-components";

export interface ConfirmationModalProps {
    isOpen: boolean;
    headline?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ButtonRow = styled.div`
   display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-top: 30px;
`;

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    headline,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
}) => {
    return (
        <Modal
            headline={headline || translate("Confirm")}
            isOpen={isOpen}
            handleClose={onCancel}
            sizeVariant="small"
            closeOnEsc
            closeOnScrimClick={false}
        >
            <Typography>{message}</Typography>
            <ButtonRow>
                <Button variant="secondary" onClick={onCancel} data-test-selector="confirmationModalCancel">
                    {cancelText || translate("Cancel")}
                </Button> 
                <Button variant="secondary" onClick={onConfirm} data-test-selector="confirmationModalConfirm">
                    {confirmText || translate("Confirm")}
                </Button>                               
            </ButtonRow>
        </Modal>
    );
};

export default ConfirmationModal;
